<script setup lang="ts">

import { makeForm } from '@library/Components/Forms/Form';
import type { IActivateVehicleModel } from '../IActivateVehicleModel';

import LicensePlate from "../../LicensePlate/LicensePlate.vue";
import SendSmsButton from "./SendSmsButton.vue";

const activeVehicleModel = defineModel<IActivateVehicleModel>( { required: true } );
const vehicleForm = makeForm( activeVehicleModel.value.vehicle! );

</script>

<template>

    <Form :form="vehicleForm" 
          v-slot="{ form, model }"
          class="w-full max-h-full items-start overflow-y-auto tracking-wider pb-12">

        <h1 class="w-full flex justify-center items-center mt-6 mb-6 3xl:mb-8 px-4 text-base 3xl:text-lg 3xl:max-w-[80%] mx-auto">
            This vehicle is already activated. You can resend the welcome SMS if they did not receive it.
        </h1>      
        
        <LicensePlate :vehicle="model" 
                      :app-name="model.appName" />

        <div class="3xl:max-w-[80%] mx-auto text-base 3xl:text-lg">

            <h1 class="mb-2 text-lg">Next Steps</h1>

            <ol class="list-decimal pl-6 flex flex-col gap-2">
                <li>
                    Confirm that the customer received the SMS with a link to download the app
                </li>
                <li>
                    Show the customer how to find their car and complete the welcome flow
                </li>
                <li>
                    Show the customer how to book their next service and recommend linking 
                    their payment card to benefit from the marketplace offers
                </li>
            </ol>
                    
            <!-- RESEND SMS BUTTON -->
            <SendSmsButton v-if="model.vehicleId != null"
                           :vehicle="model"
                           :form="form"
                           class="mt-4 3xl:mt-6"
            />

            <div class="flex justify-center mt-4 3xl:mt-6">
                <Button variant="text"
                        class="!h-11 3xl:!h-14 w-32 3xl:w-48"
                        @click="() => activeVehicleModel.reset()">
                    Close
                </Button>
            </div>

        </div>

    </Form>

</template>